<template>
  <div class="donation-type-select">
    <p v-if="$t(`donationForm.donationType.prompt`)">
      <small
        class="prompt-text"
        v-html="promptText"
      />
    </p>
    <div class="donation-types form-check-group">
      <div
        v-for="(type) in types"
        :key="type"
        class="option"
      >
        <input
          :id="`${type}-donation-type`"
          type="radio"
          v-model="donationType"
          :value="type"
        >
        <label :for="`${type}-donation-type`">
          {{ $t(`donationForm.donationType.${type}`) }}
          <DonationFrequencySelect
            v-if="type.match(/^(?!.*oneOff).*$/)"
            v-model="donationType"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import DonationFrequencySelect from '@/components/donation/DonationFrequencySelect'
import { useRootStore } from '@/stores/root'
import { useDonationStore } from '@/stores/donation'

export default {
  name: 'DonationTypeSelect',
  setup () {
    const rootStore = useRootStore()
    const donationStore = useDonationStore()
    return { rootStore, donationStore }
  },
  components: { DonationFrequencySelect },
  computed: {
    hideOneOff () { return this.rootStore.hiddenFrequencies.includes('oneOff') },
    hideRegular () {
      const hidden = this.rootStore.hiddenFrequencies
      if (hidden.includes('regular')) return true
      const available = Object.keys(this.$l10n.availableFrequencies.regular)
      return available.length > 0 && available.every(f => hidden.includes(f))
    },
    types () {
      if (this.hideOneOff) {
        return [this.regularType]
      } else if (this.hideRegular) {
        return ['oneOff']
      } else {
        return [this.regularType, 'oneOff']
      }
    },
    regularType () {
      return (this.donationType.match(/^(?!.*oneOff).*$/) ? this.donationType : 'monthly')
    },
    donationType: {
      get () { return this.donationStore.type },
      set (newValue) { this.donationStore.setType(newValue) }
    },
    promptText () {
      if (this.rootStore.appeal && (this.$tm(`appeals.${this.rootStore.appeal}.donationType.prompt`)[0])) {
        return this.$t(`appeals.${this.rootStore.appeal}.donationType.prompt`)
      } else {
        return this.$t(`donationForm.donationType.prompt`)
      }
    }
  },
  watch: {
    types (val) {
      if (val.length === 1) {
        const type = val[0]
        this.donationStore.setType(type)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .donation-type-select {
    display: block;
    overflow: initial;
  }

  :deep(.prompt-text) {
    a {
      color: var(--color-web-orange);
    }
  }

  .donation-types {
    display: flex;
    gap: 5px;
    flex-direction: row;
    margin-bottom: 1em;
    width: 100%;
    @include on-mobile{
      flex-direction: column;
    }

    .option {
      position: relative;
      flex: 1 1 0px;
      text-align: center;
      margin-right: 0;
      cursor: pointer;
      transition: all 200ms ease-in-out;
    }
  }
</style>
